/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../static/scss/resources/default.variables.scss';
@import '../../../static/scss/resources/default.style.scss';

.wizard-header {
  padding: 6px!important;
  min-height: $title-height;
  max-height: $title-height;
  background-color: $alert-header-bg;
  font-size: $font-size-base;
  font-weight: bold;
  color: $alert-header-fg;
  overflow: hidden;
  white-space: nowrap;
  border-radius: 0rem;
  border-top-left-radius: $panel-border-radius;
  border-top-right-radius: $panel-border-radius;
  border-bottom: none;
}

.wizard-content {
  position: absolute;
  overflow: auto;
  top: $title-height;
  bottom: $footer-height-calc;
  left: 0;
  right: 0;
}

.pgadmin-wizard .wizard-buttons {
  border-top: $panel-border;
  padding: $footer-padding
}

/* match the footer */
.pgadmin-wizard .wizard-footer {
  min-height: $footer-min-height;
  border: none;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}

/* Error message css */
.pgadmin-wizard .error_msg_div {
  background: $color-bg;
  font-size: 13px;
}

.pgadmin-wizard .error_msg_div p {
  background: $color-bg;
  color: $color-danger;
}
